// Turn an axios error into a message that's useful to show on screen.
export const getErrorMessage = (err) => {
    if (err?.response) {
        const { status, data } = err.response;
        const detail = typeof data === 'string' ? data : data?.message || data?.title;
        return detail ? `API error ${status}: ${detail}` : `API error ${status}`;
    }
    if (err?.request) return "Can't reach the Ops Portal API. Check your connection or try again.";
    return err?.message || 'Something went wrong';
};
